import { ReactElement } from 'react';

import { useIframeSrc } from './hooks/useIframeSrc';

interface CommonFieldProps {
  name: string;
  title: string;
  loading: 'lazy' | 'eager';
  onLoad?: () => void;
  labelPosition: 'default' | 'inline';
}

export const CommonField = ({
  name,
  title,
  loading,
  onLoad,
  labelPosition,
}: CommonFieldProps): ReactElement => {
  const iframeSrc = useIframeSrc(name, labelPosition);

  return (
    <iframe
      src={iframeSrc}
      title={title}
      height={'48px'}
      width="100%"
      loading={loading}
      onLoad={onLoad}
    />
  );
};
